exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".product-single---3cFc0{margin-bottom:20px;height:400px}.product-img---4f1eP{height:260px}.product-img-img---3HNR6{width:auto!important;max-width:100%;max-height:258px}", ""]);

// exports
exports.locals = {
	"product-single": "product-single---3cFc0",
	"product-img": "product-img---4f1eP",
	"product-img-img": "product-img-img---3HNR6"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1&modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./~/sass-resources-loader/lib/loader.js!./src/app/directives/product/search-simple/style.scss
// module id = 362
// module chunks = 0